import * as React from 'react'
import { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import useMediaQuery from '@mui/material/useMediaQuery'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'

import Redirect from './components/Redirect'

const MainContent = () => {

    const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)")
    const [darkMode] = useState(prefersDarkMode)
    const darkTheme = createTheme({
        palette: {
          mode: 'dark',
          background: {
            default: '#121212'
            }
        },
      })

    useEffect(() => {
    }, [darkMode])

    return (
        <ThemeProvider theme={darkTheme}>
            <Box sx={{ display: 'flex' }}>
                <CssBaseline enableColorScheme />
                <Redirect />
            </Box>
        </ThemeProvider>
    )
}

const App = () => {
    return (
        <MainContent />
    )
}

export default App